import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-grid" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 u-form-grid-nospace-y" }
const _hoisted_3 = { class: "collapse-tarif" }
const _hoisted_4 = {
  class: "c-collapse c-collapse--is-initialized",
  "data-collapse": "data-collapse",
  "data-collapse-multiple": "true"
}
const _hoisted_5 = { class: "o-grid o-grid--no-y-gutter table-tariff-collapse-wrapper" }
const _hoisted_6 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 table-switcher button-select" }
const _hoisted_7 = { class: "o-grid o-grid--no-y-gutter" }
const _hoisted_8 = { class: "collapse-switcher table-wide-button table-wide-button__header" }
const _hoisted_9 = {
  key: 0,
  class: "c-collapse__content",
  "aria-labelledby": "collapse-tariff-table-button",
  id: "collapse-tariff-table"
}
const _hoisted_10 = {
  class: "c-collapse c-collapse--is-initialized",
  "data-collapse": "data-collapse",
  "data-collapse-multiple": "true"
}
const _hoisted_11 = { class: "tariff-details-table js-tarifoptions-table" }
const _hoisted_12 = { class: "o-grid o-grid--no-y-gutter" }
const _hoisted_13 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200" }
const _hoisted_14 = { class: "o-grid o-grid--no-y-gutter table-wide-button table-wide-button__footer" }
const _hoisted_15 = ["href", "download"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_leistungstabelle_zeile = _resolveComponent("leistungstabelle-zeile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["c-collapse__item", {
              'c-collapse__item--is-expanded': _ctx.isAusgeklappt,
              'c-collapse__item--is-collapsed': !_ctx.isAusgeklappt,
            }]),
            style: {"height":"56px"}
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480" }, null, -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "c-collapse__header no-outline",
                      "aria-expanded": "false",
                      id: "collapse-tariff-table-button",
                      "aria-controls": "collapse-tariff-table",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zeigeInhalt && _ctx.zeigeInhalt(...args)))
                    }, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "c-collapse__header-with-icon" }, " Leistungen vergleichen ", -1)),
                      _createVNode(_component_icon_sprite, {
                        "icon-name": "icon-arrow-up",
                        "css-klassen": "c-collapse__icon"
                      })
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.isAusgeklappt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"o-grid gimmick gimmick__top\"><div class=\"o-grid__cell o-grid__cell--12 o-grid__cell--3-480 gimmick-left-col\"></div><div class=\"o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 gimmick-right-col\"><div class=\"o-grid o-grid--no-y-gutter add-on\"><div class=\"tariff-column-1 add-on__option\"></div><div class=\"tariff-column-2 add-on__option\"></div><div class=\"tariff-column-3 add-on__option\"></div></div></div></div>", 1)),
                      (_ctx.isAusgeklappt)
                        ? (_openBlock(), _createBlock(_component_leistungstabelle_zeile, {
                            key: 0,
                            zeilen: _ctx.zeilen,
                            aktiveLinie: _ctx.aktiveLinie
                          }, null, 8, ["zeilen", "aktiveLinie"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480" }, null, -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            class: "detailed-services-comparison",
                            href: _ctx.link,
                            download: _ctx.link,
                            target: "_blank"
                          }, " Detaillierte Leistungsübersicht herunterladen", 8, _hoisted_15)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ]))
}